import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAddPermissionButton = styled('div')`
  color: var(--Placeholder, #6e6e6e);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px; /* 257.143% */
  cursor: pointer;
`;

export const StyledActionCell = styled(TableCell)`
  text-align: center;
  padding: 0px;
  padding-left: 8px;
  width: 128px;
  max-width: 128px;
  min-width: 128px;
`;

export const StyledSelectCell = styled(TableCell)`
  width: 230px;
  max-width: 230px;
  min-width: 230px;
  padding: 4px;
`;

// Keeps the user's name in view while the wide permissions table scrolls
// horizontally inside its panel.
export const stickyNameCellSx = {
  position: 'sticky',
  left: 0,
  zIndex: 1,
  backgroundColor: '#fff',
} as const;
